export default {
  nuevo: "New attachment",
  pregEliminar: "Are you sure you want to delete this attachment?",
  titleSubir: "Upload attachment",
  labelSeleccionar: "Click to select file",
  seleccionarTipo: "Select type",
  subir: "Upload",
  cotizacion: "Quotation",
  orden: "Purchase order",
  certificado: "Certificate",
  factura: "Invoice",
  errorTamaño: "The file size exceeds the 10 MB limit",
}
